var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankYouHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 47,
    viewBox: "0 0 47 47",
    width: 47,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5580295 33.1244852h3.3765657v-3.5442561h-3.3765657zm4.7626247-6.3313181h-6.1486837c-.7656086 0-1.386059.6239218-1.386059 1.393531v6.3313181c0 .7696091.6204504 1.393531 1.386059 1.393531h6.1486837c.7654825 0 1.3860589-.6239219 1.3860589-1.393531v-6.3313181c0-.7696092-.6205764-1.393531-1.3860589-1.393531z",
    fill: "#ef426f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.0320059 29.5802798h4.9501206v14.6291617h2.772118v-16.0226927c0-.7696092-.6205764-1.393531-1.386059-1.393531h-7.7222386c-.7654826 0-1.386059.6239218-1.386059 1.393531v16.0226927h2.772118z",
    fill: "#ef426f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.9972142 22.0395795c-.7654826 0-1.386059.6239218-1.386059 1.393531v20.7762803h-3.8568981-2.772118-4.9501206-2.772118-15.99701069v-20.7762803c0-.7696092-.6204504-1.393531-1.38605898-1.393531h-2.13049866l18.69062733-18.68104311 18.6907534 18.68104311zm6.4679812.4052642-22.0510643-22.03945286c-.540689-.54043666-1.4137802-.54043666-1.9544692 0l-22.0508123 22.03945286c-.39805094.3979164-.51813405.9978948-.30405094 1.5195822.2139571.5216873.71999464.8622156 1.28134852.8622156h4.10462467v20.1323423c0 1.1234394.93836193 2.037469 2.091563 2.037469h18.69365145 6.462185 6.5535389c1.1533271 0 2.091563-.9140296 2.091563-2.037469v-20.1323423h4.1047507c.5613538 0 1.0672654-.3405283 1.2813485-.8622156.2139571-.5216874.093874-1.1216658-.304177-1.5195822z",
    fill: "#E3215F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouHouse);
export default __webpack_public_path__ + "static/media/thankYou-house.6adcf8187d3f26f51fc7cdb1248ee81c.svg";
export { ForwardRef as ReactComponent };